import React from "react";
import Select from "react-select";
import "../segment.css";
import { useEffect, useRef, useState } from "react";
import { IMetaData, IFilterDef, FilterDef, IExpression, IFilter, IRule, FilterUtils } from "../../../../services/SegmentService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCross, faPlus, faTachometerAlt, faThumbsDown, faXmark, faXmarkSquare } from "@fortawesome/free-solid-svg-icons";
import { boolean } from "yup";


export interface RuleDetailProps {
    rule: IRule;
    filterDef: IFilterDef;
    segmentMeta: any;
    changeRuleData: (rule: IRule, data: any) => void;
}

export const styles = {
    control: (base) => ({
        ...base,
        minHeight: 20,
        width: '100%',
        margin: '0',
        padding: '0'
    }),
    dropdownIndicator: (base) => ({
        ...base,
        paddingTop: 0,
        paddingBottom: 0,
    }),
    clearIndicator: (base) => ({
        ...base,
        paddingTop: 0,
        paddingBottom: 0,
    }),
};

export const CustomerRuleDetail = ({ rule, filterDef, segmentMeta, changeRuleData }: RuleDetailProps) => {

    const [ex, setEx] = useState<IExpression | null>(null);
    const [where, setWhere] = useState<any>({
        operand: rule.data?.where[0]?.operand ?? null,
        value: rule.data?.where[0]?.value ?? null,
        expressionKey: rule.data?.where[0]?.expressionKey ?? null
    });

    useEffect(() => {

        let expression;
        let expressionKey;

        if(rule.data.filterDef.key == "customAttributes") {
            expression = rule.data.filterDef?.expressions.find(e => e.key == where.expressionKey)!;
            expressionKey = expression ? expression.key : null;
        } else {
            expression = rule.data.filterDef?.expressions[0]!;
            expressionKey = expression ? expression.key : null;
        }

        setEx(expression);
        setWhere({
            ...where,
            expressionKey: expressionKey
        });

    }, [rule.data.filterDef]);

    useEffect(() => {

        updateParent();

    }, [where]);

    const updateParent = () => {

        changeRuleData(rule, {
            segmentMeta: segmentMeta,
            where: [where],
            filterDef: filterDef
        });
    }

    const operandChange = (e) => {
        setWhere({
            ...where,
            operand : e?.value
        });
    }

    const valueChange = (v) => {
        
        setWhere({
            ...where,
            value : v
        });
    }

    const expressionChange = (e) => {

        const _ex = filterDef.expressions.find(_e => _e.key == e?.value)!;
        setEx(_ex);
        setWhere({
            operand: null,
            expressionKey: _ex?.key,
            value: null
        });
    }


    const renderRuleDetail = () => {

        let filterDefDetail;
        let filterDefOperand;
        let filterDefOption;
        let subFilterDef;

        //New Rule
        if (filterDef) {


            if (filterDef.key == "customAttributes") {
                subFilterDef =
                    <Select className="col-sm-3"
                        onChange={e => expressionChange(e)}
                        options={filterDef.expressions.map(e => ({ "label": e.readableName, "value": e.key }))}
                        value={where.expressionKey ? { "label": where.expressionKey, "value": where.expressionKey } : undefined}
                        styles={styles}
                    />
            } else {

                subFilterDef = <></>
            }

            filterDefOperand =
                <Select className="col-sm-3" options={ex?.opList.map(o => ({ "label": o, "value": o }))}
                    onChange={e => operandChange(e)}
                    placeholder="Operation" value={where.operand ? { label: where.operand, value: where.operand } : undefined}
                    styles={styles}
                />

            if (ex?.options && ex.options.length > 0) {
                let selectedVal = rule.ruleId ? ex?.options.filter(o => o.key == where.value).map(o => {
                    return {
                        label: o.readableName,
                        value: o.key
                    }
                })[0]! : undefined;

                filterDefOption =
                    <Select className="col-sm-3" onChange={e => valueChange(e?.value)}
                        options={ex.options.map(o => ({ "label": o.readableName, "value": o.key }))}
                        value={selectedVal} placeholder="Value"
                        styles={styles}
                    />
            } else {
                filterDefOption =
                    <div className="col-sm-3">
                        <input className="form-control" placeholder="Value" onChange={e => valueChange(e.target.value)} type="text" value={where.value ? where.value : ""}></input>
                    </div>
            }

            filterDefDetail =
                <div className="col-sm-8">
                    <div className="row">
                        {subFilterDef}
                        {filterDefOperand}
                        {filterDefOption}
                    </div>
                </div>

        } else {
            filterDefDetail =
                <div className="col-sm-8">
                    <div className="row">
                    </div>
                </div>
        }

        return filterDefDetail;
    }


    return (
        <>
            {renderRuleDetail()}
        </>
    );

}